module.exports = require('./helpers/bundle-url').getBundleURL('7S8md') + "lslogofooter.5045c8cd.png" + "?" + Date.now();